export default {
  newToOrbit: "New to Orbit?",
  email: "Email",
  emailRequired: "E-mail is required",
  emailValid: "E-mail must be valid",
  emailIncorrect:
    "Invalid credentials. Please check your spelling and try again.",
  passwordResetCode: "Password reset code",
  passwordResetCodeRequired: "Password reset code is mandatory",
  password: "Password",
  createPassword: "Create password",
  confirmPassword: "Confirm password",
  back: "Back",
  forgotPassword: "Forgot password",
  resetMyPassword: "Reset my password",
  setMyPassword: "Set my password",
  continue: "Continue",
  register: "Sign-up",
  signIn: "Log in",
  signInWithAzure: "Sign In with Azure",
  signUp: "Sign up",
  signInWithDelaval: "Delaval Employees/Partners",
  signInWithOneDelaval: "SignIn with One Delaval Id",
  signUpForYourAccount: "Sign up for your account",
  logInToYourAccount: "Log in to your account",
  confirmText: "Confirm your email",
  emailIsVerified: "Email has already been verified. Please go to login page.",
  emailNotVerified:
    "Confirmation token is expired. Please Sign Up again to get connect with us.",
  aVerificationLinkHaveBeenSentToYourEmail:
    "A verification link has been sent to your email. You may close this tab",
  resetLinkSentToYourEmail: "Reset code sent to your email",
  resetLinkSentToYourEmailForced:
    "Reset code sent to your email. You may close this tab",
  setPasswordSuccess: "Password has been set successfully.",
  closeTab: "Close",
  errors: {
    invalidOrExpiredLinkWithNewCode:
      "Password reset code is invalid or expired. Please try again.",
    invalidOrExpiredLink:
      "Invalid invitation email, Please check your inbox and make sure you use the most recent invitation email.",
    userDoesNotExist: "User does not exist",
    invalidPasswordPolicy:
      "Password must meet complexity requirements (Uppercase, lowercase, Number and special character(!@#?$%^&*._-))",
    incorrectUsernameOrPassword:
      'Incorrect email or password, please try again or press "Forgot Password"',
    loginFailed: "Login failed",
    invalidPasswordResetCode:
      "Invalid password reset code provided, please try again.",
    userIsNotConfirmed: "User is not confirmed.",
    default: {
      signIn: "Log in failed",
      resetPassword: "Password reset failed",
      resetPasswordLogin: "Password Creation Failed",
    },
  },
  emailLabel: {
    checkEmail: "Check your email",
    newEmailSend: "We have sent you a new link that works for 24h.",
    checkSpamFolder:
      "Check the spam-folder if you have not recieved an email from us.",
    resendLink: "Re-send the link",
    linkExpired: "Your link has expired",
    tryNewLink:
      "The invitation link you used has expired, try sending a new link to your email.",
    sendNewLink: "Send a new link",
    alreadyHaveAnAccount: "Already have an account?",
  },
  confirmPasswordRules: "Passwords do not match",
  agreeLabel: "I agree to",
  agreeLabelForPolicy:
    "I agree to the collection, use and processing of data in connection with DeLaval Plus and DeLaval Plus Services as described in the",
  termsAndConditionText: "DeLaval Software and Online Services Terms of Use",
  privacyPolicyText:
    "DeLaval Software and Online Services Data and Privacy Statement",
  passwordRules: {
    required: "Password is mandatory",
    minlength: "The password must be at least 8 characters",
    maxlength: "The password should be 16 characters long.",
    uppercase: "The password must include a uppercase letter",
    lowercase: "The password must include a lowercase letter",
    spacecase: "Space is not allowed.",
    digit: "The password must include a digit",
    special: "The password must include a special character",
    allowedPassword:
      "Password should be between 8 and 16 characters containing a mix of upper case, lower case, digit, and a special character (!@#?$%^&*._-)",
  },
  eula: {
    expander: "By continuing login, you agree to Terms of Use",
    linkToToU: "SoftwareOnlineServiceToU",
    linkToDP: "SoftwareOnlineServiceDataPrivacy",
  },
};
